import React from 'react';
import './About.css';

const About = () => {
 return (
  <section id='about' className='section about'>
   <div className='container'>
    <div className='about-content'>
     <div className='about-text animate-fade-in-left'>
      <h2 className='section-title'>About Vi Le CPA, PLLC</h2>
      <p className='about-description'>
       Vi Le CPA, PLLC is a premier accounting firm that offers professional,
       personalized services to its clients in the Puget Sound area. With a
       focus on quality and customization, the firm delivers tailored solutions
       that help businesses achieve their financial and operational goals.
      </p>
      <p className='about-description'>
       We offer a wide range of services, including tax management, accounting
       services, financial planning, and bookkeeping. Whether a client is an
       individual or a business, we have the expertise to help you with your
       financial needs.
      </p>
      <p className='about-description'>
       In addition to tax services, Vi Le CPA, PLLC also offers a full range of
       accounting services, including financial statement preparation, mergers
       and acquisitions, business valuations, and debt and finance advising. The
       firm's team of experienced CPAs is dedicated to delivering accurate and
       timely information, helping you make informed decisions about your
       financial future.
      </p>
     </div>

     <div className='about-features animate-fade-in-right'>
      <div className='feature hover-lift delay-1'>
       <h3>Quality Focus</h3>
       <p>We prioritize accuracy and attention to detail in all our services</p>
      </div>
      <div className='feature hover-lift delay-2'>
       <h3>Timely Service</h3>
       <p>Quick turnaround times without compromising on quality</p>
      </div>
      <div className='feature hover-lift delay-3'>
       <h3>Personalized Approach</h3>
       <p>Customized solutions tailored to your specific needs</p>
      </div>
      <div className='feature hover-lift delay-4'>
       <h3>Expert Guidance</h3>
       <p>Professional advice to help you make informed financial decisions</p>
      </div>
     </div>
    </div>
   </div>
  </section>
 );
};

export default About;
